<template>
    <div class="columns">
        <div class="column is-12-mobile is-12-desktop is-12-widescreen">

            <div class="level">
                <div class="level-left">
                    <div class="title is-marginless is-paddingless">Reviews
                        <span v-if="is_loading || fetching_data"
                              class="button is-white has-text-right preloader"
                              :class="{'is-loading': (is_loading || fetching_data)}"></span>
                    </div>
                </div>
            </div>

            <div class="columns" v-if="!is_loading">

                <div class="columns">
                    <div class="column is-desktop is-12-mobile is-full-tablet is-paddingless margin-top-4 is-full-widescreen">
                        <span class="is-size-7 has-text-grey is-full-mobile">Review ID: &nbsp;</span>
                    </div>
                </div>
                <div class="column is-paddingless margin-right-20 is-2-desktop is-2-tablet">
                    <search v-on:search="search($event)"
                            placeholder="Search by review ID"
                            :addMarginLeft=false
                            desktopCss="is-12-tablet is-11-desktop"
                            class="is-paddingless is-marginless"
                            :integerOnly="true"
                    ></search>
                </div>

                <div class="columns">
                    <div class="column is-narrow">
                        <span class="is-size-7 has-text-grey is-pulled-left">Status:&nbsp;</span>
                    </div>
                    <div class="column is-narrow is-paddingless">
                        <multiple-selection-drop-down
                            btnMinWidth="button-width-200px"
                            dropdownName="payment_method"
                            :checkedItems="checkedItems"
                            :items.sync="status"
                            ref="status"
                            :placeHolder="statusPlaceholder"
                            @multiple-dropdown-changed="setReviewStatus($event)"
                            class="is-paddingless is-marginless"></multiple-selection-drop-down>
                    </div>
                </div>

                <div class="columns">

                    <div class="column is-narrow ">
                        <span class="is-size-7 has-text-grey is-pulled-left">Date:&nbsp;</span>
                    </div>
                    <div class="column is-narrow is-paddingless is-12-desktop is-12-tablet">
                        <input
                            type="text"
                            id="review_date_trigger"
                            class="airbnb-datepicker-trigger padding-right-0 margin-right-10"
                            placeholder="Select dates"
                            ref="review_date_datepicker"
                            :value="formatDates(review_date_from, review_date_to, 'review')"
                        >

                        <AirbnbStyleDatepicker
                            :trigger-element-id="'review_date_trigger'"
                            :showShortcutsMenuTrigger="false"
                            :mode="'range'"
                            :fullscreen-mobile="true"
                            :date-one="review_date_from"
                            :date-two="review_date_to"
                            :fullscreenMobile="true"
                            @apply="getReviewsListings(1)"
                            @date-one-selected="val => { review_date_from = val }"
                            @date-two-selected="val => { review_date_to = val }"
                        >
                            <template slot="close-icon">
                                <i class="far fa-times-circle"></i>
                            </template>
                        </AirbnbStyleDatepicker>
                    </div>
                    <div class="column  padding-top-0 padding-bottom-0 is-narrow is-12-desktop is-12-tablet">
                      <button class="button is-button-grey is-button-small margin-right-10"
                              type="reset" @click.prevent="resetFilter">RESET</button>
                    </div>
                </div>


            </div>

            <p v-if="!fetching_data" v-resultsCount="[total_records, all_records]"></p>

            <div class="level" v-if="!is_loading">
                <table class="table is-size-7-touch is-marginless is-fullwidth">
                    <thead>
                    <tr>
                        <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey"><span class="fix-width-column-date">Date&nbsp;Published</span></td>
                        <td class="pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey">Business</td>
                        <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Title</td>
                        <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Review ID</td>
                        <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Reviewer Email</td>
                        <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Review Status</td>
                        <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">NPS</td>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-if="(is_loading && items.length === 0) || (!fetching_data && items.length === 0)">
                            <td class="is-narrow pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey" colspan="8">
                                <p class="has-text-centered is-padded-20">No results found</p>
                            </td>
                        </tr>
                        <tr class="margin-bottom-20" v-for="(item, index) in items"  v-if="items.length > 0">
                            <td class="is-narrow-mobile is-desktop break-all">{{item.created_at | prettyDate}}</td>
                            <td class="is-narrow-mobile is-desktop break-all">
                                <router-link :to="`/business/${item.bizSlug}/billing`" target="_blank">{{ asText(item.bizName, 80) }}</router-link>
                            </td>
                            <td class="is-narrow-mobile is-desktop break-all" @click="goToReview (item)">{{ asText(item.review_title, 100) }}</td>
                            <td class="is-narrow-mobile is-desktop break-all" @click="goToReview (item)">{{item.id}}</td>
                            <td class="is-narrow-mobile is-desktop break-all">
                                <router-link :to="`/reviewer-detail/${item.reviewerId}`" target="_blank">{{item.email}}</router-link>
                            </td>
                            <td class="is-narrow-mobile is-desktop break-all">
                                <span v-if="item.status_id === 1">Active</span>
                                <span v-else>Deleted</span>
                            </td>
                            <td class="is-narrow-mobile is-desktop break-all">
                                <span :class="getNPSClass(item.nps_rating)">{{item.nps_rating}}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="level">
                <paginator :dataSet="dataSet" @changed="getReviewsListings"></paginator>
            </div>

        </div>
    </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
  import axios from 'axios'
  import Paginator from './../../components/Paginator.vue'
  import misc from '../../mixins/misc.js'
  import qs from 'qs'
  import moment from 'moment'
  import Search from '../../components/Search.vue'
  import MultipleSelectionDropDown from './../../components/MultipleSelectionDropDown.vue'
  import format from 'date-fns/format'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - ReviewsListing'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Reviews Listing'
      })
    },
    components: {Paginator, Search, MultipleSelectionDropDown},
    mixins: [misc],
    data () {
      return {
        searchMarginLeft: false,
        no_of_items: 0,
        is_loading: true,
        fetching_data: false,
        items: [],
        dataSet: {},
        page: undefined,
        total_records: 0,
        checkedItems: [],
        statusPlaceholder: 'Select Status',
        deleteReason: '',
        deleteReviewStatus: false,
        status: [
          {
            name: 'Active',
            value: '1'
          },
          {
            name: 'Deleted',
            value: '2'
          }
        ],
        review_date_from: '',
        review_date_to: '',
        review_dates_set: false,
        status_filter: '',
        dateFormat: 'DD-MM-YYYY',
        all_records: -1
      }
    },
    created () {
      this.setFilterValues()
      this.getReviewsListings(null)
      if (JSON.parse(localStorage.getItem('admin')).isLoadedFirstTime) {
        let adminObj = {}
        Object.assign(adminObj, JSON.parse(localStorage.getItem('admin')), {isLoadedFirstTime: false})
        localStorage.setItem('admin', JSON.stringify(adminObj))
        window.location.reload(true)
      }
    },
    methods: {
      handleChange () {
        alert('qoek')
      },
      /**
       * set all filter values by using query string
       *
       * @returns {void}
       */
      setFilterValues () {
        if (this.$route.query.keyword) {
            this.keyword_string = this.$route.query.keyword
            this.keyword_search = qs.stringify({keyword: this.$route.query.keyword})
        }
        if (this.$route.query.review_date_from) {
            this.review_date_from = this.$route.query.review_date_from
        }
        if (this.$route.query.review_date_to) {
            this.review_date_to = this.$route.query.review_date_to
            this.review_dates_set = true
        }
        if (this.$route.query.status) {
            this.status_filter = this.$route.query.status
            let filterArr = this.status_filter.split(`&status`)
            let filteredArr = filterArr.filter(function (val) {
                return val !== ''
            })
            if (filteredArr.length > 1) {
                this.statusPlaceholder = 'Multiple selections'
            } else if (filteredArr.length === 1) {
                let statusPlaceholder = this.status.filter((item) => {
                    if (item.value.substring(item.value.indexOf('=') + 1) === filteredArr[0].substring(filteredArr[0].indexOf('=') + 1)) {
                        return item
                    }
                })
                this.statusPlaceholder = statusPlaceholder.length > 0 ? statusPlaceholder[0].name : 'Select Status'
            }
            filteredArr.forEach((value) => {
                this.checkedItems.push(value.substring(value.indexOf('=') + 1))
            })
        }
      },
      // redirect to review detail
      goToReview (revItem) {
        localStorage.setItem('review_redirect', true)
        localStorage.removeItem('sweep')
        let filters = qs.stringify({
            keyword: this.keyword_string,
            status: this.status_filter,
            review_date_from: this.review_date_from,
            review_date_to: this.review_date_to
        })
        this.$router.push(`/business/${revItem.bizSlug}/review/${revItem.permalink}/${revItem.id}?${filters}&page=${this.page}`)
      },
      preventClick (event) {
        event.stopPropagation()
      },
      resetFilter () {
        // reset all filters
        this.status_filter = ''
        this.review_date_from = ''
        this.review_date_to = ''
        this.keyword_string = ''
        this.keyword_search = ''
        this.review_dates_set = false
        window.events.$emit('reset-filters')
        this.$router.push('/reviews-listing')
        location.reload()
        this.getReviewsListings(1)
      },
      /**
       * Search keyword/term to search for
       * @param {string} search search term/keyword
       * @returns {void}
       */
      search (search) {
        this.keyword_search = qs.stringify({keyword: search})
        this.keyword_string = search
        this.getReviewsListings(1)
      },
      /**
       * Make request to api to get reported reviews listings
       * @returns {number | null}
       * @param {number} page page number to paginate to
       */
      getReviewsListings (page) {
        this.page = page || 1
        this.fetching_data = true
        axios.get(this.url(page, this.keyword_search))
            .then((response) => {
              this.is_loading = false
              this.fetching_data = false
              this.refresh(response)
              response.data.data = undefined
            })
            .catch(() => {
              flash('You are not authorized to view this resource.', 'is-danger')
              this.is_loading = false
              this.fetching_data = false
            })
      },
      /**
       * Compute URI to make call to api with.
       * @param {string} page starting page to request
       * @param {string} keyword search keyword
       * @return {string}
       */
      url (page, keyword) {
        let query = location.search.match(/page=(\d+)/)
        if (!page) {
          page = query ? query[1] : 1
        }
        if (keyword !== undefined && this.keyword_string !== 0) {
          page += `&${keyword}`
        }
        if (this.review_dates_set) {
          page += `&${qs.stringify({review_date_from: this.review_date_from, review_date_to: this.review_date_to})}`
        }
        if (this.status_filter !== '') {
          page += `${this.status_filter}`
        }
        return `/reviews/?page=${page}`
      },
      /**
       * Sets Status method to filter by
       * @param {object} event status
       * @returns {void}
       */
      setReviewStatus (event) {
        if (event.value.length > 0) {
            this.status_filter = '&' + qs.stringify({status: event.value})
        } else {
            this.status_filter = ''
        }
        this.getReviewsListings(1)
      },
      /**
       * Sets invoice date to filter by
       * @param {string} dateFrom date from range
       * @param {string} dateTo date to range
       * @param {string} dateType join/end as possible options
       * @returns {object}
       */
      formatDates (dateFrom, dateTo, dateType) {
        let formattedDates = ''
        if (dateFrom) {
          formattedDates = format(dateFrom, this.dateFormat)
        }
        if (dateTo) {
          formattedDates += ' - ' + format(dateTo, this.dateFormat)
        }

        if (this[dateType + '_date_from'] || this[dateType + 'date_to']) {
          this[dateType + '_dates_set'] = true
        }

        if (!this[dateType + '_date_from'] && !this[dateType + 'date_to']) {
          this[dateType + '_dates_set'] = false
        }

        return formattedDates
      }
    },
    filters: {
      prettyDate (date) {
        return moment(date).format('DD-MM-YYYY')
      },
      prettyTime (date) {
        return moment(date).format('HH:mm')
      }
    }
  }
</script>

<style scoped>
    .table td, .table th {
        border: none;
    }

    .table > tbody > tr {
        background-color: #f5f5f5 !important;
        margin-bottom: 10px;
    }

    .table > tbody > td {
        margin-bottom: 20px;
    }

    tr {
        cursor: pointer;
    }
    .delete-reason{
        width: 100% !important;
        resize: none;
        padding: 5px;
    }
    .modal-card-foot > button{
        float: right;
    }

    .headnewcl{
        flex-direction:column;
    }
    .headnewcl p{
        text-align:left;    display: block;
        width: 100%;
    }
    .btninline{
        display:flex;justify-content:space-between;
    }
    .delete-review button{
        margin-top:10px;
        padding: 4px;
        border-radius: 5px;
    }
    .notify-check-section{
        margin-top: 5px;
    }
    .delete-review-footer{
        display: flex;
        justify-content: flex-end;
    }
    span.fix-width-column-date {
        width: 80px;
        display:block;
    }

    .table a {
        text-decoration: underline;
    }

    .break-all {
        word-break: break-all;
    }
</style>



// WEBPACK FOOTER //
// src/pages/reviews/ReviewsListing.vue